export default {
  ENGLISH: 'EN',
  ROMANIAN: 'RO',
};
